import { render, staticRenderFns } from "./personalpaymentsreport.vue?vue&type=template&id=37622c48&"
import script from "./personalpaymentsreport.vue?vue&type=script&lang=js&"
export * from "./personalpaymentsreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports